import {
  CompletedStatus,
  FailedStatus,
  ExpiredStatus,
  OngoingStatus,
  PendingStatus,
  AbandonedStatus,
} from 'components/ProjectStatuses';
import { ProjectOnboardingStatus } from 'store/models/Project';

export const StatusToText = {
  [ProjectOnboardingStatus.DRAFT]: 'Pending',
  [ProjectOnboardingStatus.PENDING_INFRA]: 'Pending',
  [ProjectOnboardingStatus.INFRA_SPINED]: 'Pending',
  [ProjectOnboardingStatus.INFRA_FAILED]: 'Failed',
  [ProjectOnboardingStatus.ABANDONED]: 'Abandoned',
  [ProjectOnboardingStatus.CERT_ADDED]: 'Ongoing',
  [ProjectOnboardingStatus.CONNECTED]: 'Ongoing',
  [ProjectOnboardingStatus.TESTED]: 'Completed',
  [ProjectOnboardingStatus.EXPIRED]: 'Expired',
};

export const MapStatusToComponent = {
  [ProjectOnboardingStatus.DRAFT]: <PendingStatus />,
  [ProjectOnboardingStatus.PENDING_INFRA]: <PendingStatus />,
  [ProjectOnboardingStatus.INFRA_SPINED]: <PendingStatus />,
  [ProjectOnboardingStatus.INFRA_FAILED]: <FailedStatus />,
  [ProjectOnboardingStatus.ABANDONED]: <AbandonedStatus />,
  [ProjectOnboardingStatus.CERT_ADDED]: <OngoingStatus />,
  [ProjectOnboardingStatus.CONNECTED]: <OngoingStatus />,
  [ProjectOnboardingStatus.TESTED]: <CompletedStatus />,
  [ProjectOnboardingStatus.EXPIRED]: <ExpiredStatus />,
};
